module.exports = __webpack_public_path__ + "img/exit.b9f3ffec.svg";